import React from 'react'
import { StyleSheet, View, ViewStyle } from 'react-native'
// import styles from './index.scss'

interface Props {
    width?: string|number;
    height?: string|number;
    style?: ViewStyle|Array<ViewStyle>;
}

const Vstack: React.FC<Props> = (props) => {

    const {
        width,
        height,
        style
    } = props;

    const VstackStyle: ViewStyle = {
        width: width,
        height: height
    };

    return (
        <View {...props} style={[styles.vstack, style, VstackStyle]}>
            {props.children}
        </View>
    );

};

const styles = StyleSheet.create({
    vstack: {
        display: 'flex',
        flexDirection: 'column'
    }
});

export {
    Vstack
}